import {font} from './simfang-normal';
export function addfont(pdf) {
  pdf.addFileToVFS('bolds', font);
  return true;
}
